import React, { memo, useEffect } from 'react';
import { Container } from 'reactstrap';
import { useHistory, useRouteParam, useQueryStringParam } from '@core/router';
import { useObservable } from '@core/utils/hooks/rxjs';
import { R } from '@core/utils/r';
import { Session } from '@modules/auth/session';
import { UserAPI } from '@business/api/user';
import { AppConfig } from '@core/utils/config';
import { UserService } from '@business/services';
import { CourseAPI } from '@business/api/course';

export const SharedCoursePage = memo(() => {
  const history = useHistory();
  const courseId = useRouteParam('id', true);
  const email = useQueryStringParam('email');
  const appId = useQueryStringParam('appId');
  const companyId = useQueryStringParam('company');
  const firstName = useQueryStringParam('firstName');
  const lastName = useQueryStringParam('lastName');
  const authUser = useObservable(Session.user$);
  useEffect(() => {
    if (authUser) {
      if (UserService.isClient(authUser)) {
        if (!R.isEmpty(appId) && !R.isEmpty(companyId) && !R.isEmpty(email) && !R.isEmpty(courseId)) {
          CourseAPI.shareAuthCourse({
            courseId: courseId || '',
            email: email || '',
            appId: appId || '',
            companyId: companyId || '',
          }).subscribe();
        }
        history.push('/client/my-courses');
      } else {
        history.push('/');
      }
    }
  }, [authUser, history]);

  useEffect(() => {
    if (!R.isEmpty(email) && !R.isEmpty(appId)) {
      AppConfig.set({ appId, companyId });
    }
  });

  useEffect(() => {
    if (R.isEmpty(email) || R.isEmpty(appId) || R.isEmpty(companyId)) {
      history.push('/login?redirect=/');
    }
    if (!authUser || (authUser && authUser.email != email)) {
      UserAPI.checkUser(email || '').subscribe(res => {
        if (res.id) {
          history.push(
            '/login?redirect=/&email=' + encodeURIComponent(email || '') + '&appId=' + appId + '&company=' + companyId + '&courseId=' + courseId,
          );
        } else {
          history.push(
            '/signUp?&email=' +
            encodeURIComponent(email || '') +
            '&appId=' +
            appId +
            '&company=' +
            companyId +
            '&courseId=' +
            courseId +
            '&firstName=' +
            firstName +
            '&lastName=' +
            lastName,
          );
        }
      });
    }
  }, [appId, authUser, companyId, email, firstName, history, lastName, courseId]);

  return (
    <div className="page-content">
      <Container fluid></Container>
    </div>
  );
});
